import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { Disclosure as HeadlessDisclosure } from "@headlessui/vue";
import { useAttrs, computed, inject } from "vue";
import { ProvideGroup } from "../Group.vue";
import Provider from "./Provider.vue";

interface DisclosureProps extends ExtractProps<typeof HeadlessDisclosure> {
  index?: number;
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Disclosure',
  props: {
    index: { default: 0 }
  },
  setup(__props: any) {

const { index } = __props as { index: number }



const group = inject<ProvideGroup>("group");

const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge([
    "py-4 first:-mt-4 last:-mb-4",
    "[&:not(:last-child)]:border-b [&:not(:last-child)]:border-slate-200/60 [&:not(:last-child)]:dark:border-darkmode-400",
    group?.value.variant == "boxed" &&
      "p-4 first:mt-0 last:mb-0 border border-slate-200/60 mt-3 dark:border-darkmode-400",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HeadlessDisclosure), _mergeProps({
    as: "div",
    defaultOpen: _unref(group)?.selectedIndex === index,
    class: _unref(computedClass)
  }, _unref(_).omit(_unref(attrs), 'class')), {
    default: _withCtx(({ open, close }) => [
      _createVNode(Provider, {
        open: open,
        close: close,
        index: index
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {
            open: open,
            close: close
          })
        ]),
        _: 2
      }, 1032, ["open", "close"])
    ]),
    _: 3
  }, 16, ["defaultOpen", "class"]))
}
}

})